module.exports = __webpack_public_path__ + "static/img/expressway-text-1.db0df1f9.png";